import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const genericQuery = groq`*[_type == 'generic' && currentPathname == $currentPathname][0]{
  ...,
  CTABanner {
    reference-> ${CTABannerRefProjection}
  }
}`;
